/** Explicit heights — shared across DropdownMenu, FilterSelectDropdown, and BaseTextInput */
export const HEIGHT_MAP: Record<string, string> = {
	DEFAULT: 'theme-luxury:h-10!',
	SMALL: 'theme-luxury:h-8!',
	LARGE: 'theme-luxury:h-14!'
};

export const INPUT_SIZE_MAP = {
	DEFAULT: `input f5 theme-luxury:py-0! theme-luxury:px-4!`,
	SMALL: `input-small f6 theme-luxury:py-0! theme-luxury:px-4!`,
	LARGE: `input-large f5 theme-luxury:py-0! theme-luxury:px-6!`
};

export type InputSize = keyof typeof INPUT_SIZE_MAP;

export type InputMode = 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url';
